/** Tâche phase 2 : ouverture du document « Parties intéressées » avec la modale des droits. */
export const PHASE_2_NEEDS_WAIT_DOCUMENT_RIGHTS_TASK =
  'phase-2.context.needsWait.documentRights' as const;

/** Tâche phase 2 : page Collaborateurs, onglet Groupes. */
export const PHASE_2_NEEDS_WAIT_GROUP_RULES_TASK = 'phase-2.context.needsWait.groupRules' as const;
